import { useEffect } from "react";
import { isDesktopSearchPaletteOpen } from "../../../components/search/DesktopSearchPaletteHost";
import { isTyping } from "./useArticleFigureView";

/**
 * K and J open the previous and the next article of the list the reader came
 * from (Figma ".DesktopTopNav / Pager"), as the pager buttons do. Null where the
 * page has no pager. The arrow keys are left to the page, which scrolls on
 * them.
 */
export function useArticlePagerKeys(
  onOpen: ((offset: -1 | 1) => void) | null
): void {
  useEffect(() => {
    if (onOpen === null) return;
    const open = onOpen;
    function handleKeyDown(event: KeyboardEvent): void {
      // A letter typed in the composer, or in any other field, is that field's.
      if (isTyping()) return;
      // The search palette over the page takes the keys for itself.
      if (isDesktopSearchPaletteOpen()) return;
      // A modal over the article (the full-screen figure, the Works score
      // sheet) keeps the reader on it: K and J would change the article under
      // it. Every MUI modal, dialog or drawer, hides the app root while open.
      const appRoot = document.getElementById("root");
      if (appRoot === null) throw new Error("should not happen: no #root");
      if (appRoot.getAttribute("aria-hidden") === "true") return;
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      if (event.repeat) return;
      // By their place on the keyboard, as F for full screen.
      switch (event.code) {
        case "KeyK":
          event.preventDefault();
          open(-1);
          return;
        case "KeyJ":
          event.preventDefault();
          open(1);
          return;
        default:
          return;
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });
}
